// extracted by mini-css-extract-plugin
export var container = "_8g-0";
export var icon = "_8g-1";
export var text = "_8g-2";